var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('b-field',{attrs:{"horizontal":""}},[_c('a',{attrs:{"href":_vm.downloadTemplate(),"download":"template-csv"}},[_c('b-button',{staticClass:"button-secondary"},[_vm._v(" Descargar Plantilla ")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }